import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { ProleisForMobileState } from '../../../../store/store.index';
import { GeneralActions } from '../../../../store/general/general.index';
import { ActivatedRoute } from '@angular/router';
import { PartViewModel } from '../../../../store/general/general.state';
import { Observable } from 'rxjs';
import { selectPartViewModel } from '../../../../store/general/general.selectors';
import { RedirectService } from '../../../services/redirect.service';

@Component({
  selector: 'app-part',
  templateUrl: './part.component.html',
  styleUrls: ['./part.component.scss'],
})
export class PartComponent implements OnInit {
  viewModel$: Observable<PartViewModel>;

  constructor(
    private store: Store<ProleisForMobileState>,
    private route: ActivatedRoute,
    public rds: RedirectService,
  ) {}

  ngOnInit() {
    this.store.dispatch(
      GeneralActions.onLoadPartViewModel({
        partId: this.route.snapshot.params.id,
      }),
    );

    this.viewModel$ = this.store.select(selectPartViewModel);
  }
}
